import { useMemo } from 'react';

export const sumPlanMacros = (batches = []) => {
  const acc = { calories: 0, protein: 0, carbs: 0, fats: 0 };
  for (const b of batches) {
    const m = b.target_macros || {};
    acc.calories += Number(b.target_calories) || 0;
    acc.protein += Number(m.protein ?? b.target_protein) || 0;
    acc.carbs += Number(m.carbs ?? b.target_carbs) || 0;
    acc.fats += Number(m.fats ?? b.target_fats) || 0;
  }
  return {
    calories: Math.round(acc.calories),
    protein: Math.round(acc.protein),
    carbs: Math.round(acc.carbs),
    fats: Math.round(acc.fats),
    mealCount: batches.length,
  };
};

const MacroBox = ({ label, value, bg, testId }) => (
  <div className="rounded-lg p-2 text-center" style={{ background: bg }} data-testid={testId}>
    <p className="text-[10px] text-white/60 uppercase tracking-wider">{label}</p>
    <p className="text-white font-bold text-base">{value}<span className="text-xs text-white/60 ml-0.5">g</span></p>
  </div>
);

export const PlanMacrosSummary = ({ batches, title = '🎯 Tu meta diaria', testIdPrefix = 'daily-total' }) => {
  const t = useMemo(() => sumPlanMacros(batches || []), [batches]);
  if (!t.calories) return null;
  return (
    <div
      className="mb-6 rounded-2xl p-4 md:p-5"
      style={{ background: 'linear-gradient(135deg, rgba(var(--brand-primary-glow), 0.10), rgba(0, 240, 255, 0.06))', border: '1px solid rgba(var(--brand-primary-glow), 0.25)' }}
      data-testid={`${testIdPrefix}-card`}
    >
      <div className="flex items-center justify-between mb-3">
        <div>
          <p className="text-[10px] uppercase tracking-widest font-bold" style={{ color: 'var(--brand-primary)' }}>{title}</p>
          <p className="text-white text-sm mt-0.5">
            {t.mealCount} {t.mealCount === 1 ? 'comida' : 'comidas'} · Total del plan por día
          </p>
        </div>
        <div className="text-right">
          <p className="text-2xl md:text-3xl font-black text-white leading-none" data-testid={`${testIdPrefix}-calories`}>{t.calories}</p>
          <p className="text-[10px] text-white/60 uppercase tracking-wider">kcal / día</p>
        </div>
      </div>
      <div className="grid grid-cols-3 gap-2">
        <MacroBox label="Proteína" value={t.protein} bg="rgba(255, 46, 147, 0.10)" testId={`${testIdPrefix}-protein`} />
        <MacroBox label="Carbos" value={t.carbs} bg="rgba(59, 130, 246, 0.10)" testId={`${testIdPrefix}-carbs`} />
        <MacroBox label="Grasas" value={t.fats} bg="rgba(251, 191, 36, 0.10)" testId={`${testIdPrefix}-fats`} />
      </div>
    </div>
  );
};

export default PlanMacrosSummary;
